import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["country", "province"]

  static targets = ["noStockBrand", "noStockBrandContainer", "stockBrand", "stockBrandContainer", "physicalAddress", "city", "postalCode"]

  connect() {
    this.toggleFields()
  }

  // outlet API: read by billing_profile_toggle_controller via the users--fields outlet
  get physicalAddress() {
    return this.physicalAddressTarget.value
  }

  // outlet API: read by billing_profile_toggle_controller via the users--fields outlet
  get city() {
    return this.cityTarget.value
  }

  // outlet API: read by billing_profile_toggle_controller via the users--fields outlet
  get postalCode() {
    return this.postalCodeTarget.value
  }

  // outlet API: read by billing_profile_toggle_controller via the users--fields outlet
  get country() {
    return this.countryOutlet.selectedCountry
  }

  // outlet API: read by billing_profile_toggle_controller via the users--fields outlet
  get province() {
    return this.provinceOutlet.value
  }

  toggleFields() {
    this.toggleStockBrand()
    this.#toggleNoStockBrand()
  }

  toggleStockBrand() {
    if (this.hasStockBrandContainerTarget) {
      const hideStockBrand = !this.countryOutlet.isNamibia || this.noStockBrandTarget.checked
      this.stockBrandContainerTarget.classList.toggle("d-none", hideStockBrand)
      if (hideStockBrand) {
        this.stockBrandTarget.removeAttribute("required")
        this.stockBrandTarget.value = ""
      } else {
        this.stockBrandTarget.setAttribute("required", true)
      }
    }
  }

  #toggleNoStockBrand() {
    if (this.hasNoStockBrandContainerTarget) {
      this.noStockBrandContainerTarget.classList.toggle("d-none", !this.countryOutlet.isNamibia)
    }
  }
}
